import { createFileRoute, Navigate } from '@tanstack/react-router'
import { payablesSummarySearchSchema } from '../../../schemas'
import { PayablesSummary } from '@/features/BillingPayments/pages/PayablesSummary/PayablesSummary'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'

export const Route = createFileRoute(
    '/_layout/billing-and-payments/payables-summary'
)({
    component: () => (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <PayablesSummary />
            </RoleRestrictedContent>
        </>
    ),
    validateSearch: payablesSummarySearchSchema,
})
